import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import moment from "moment";
import {useContext, useState} from "react";
import {Box, Button, Card, CardHeader, Link, Modal, Typography} from "@mui/material";
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton, useGridApiRef
} from "@mui/x-data-grid";
import Carousel from "react-material-ui-carousel";
import { useAuthState } from 'react-firebase-hooks/auth';
import axios from "../../../utils/axios";
import {BASE_HOST, getAccountAPIHeader} from "../../../utils/urlConst";
import {TableMoreMenu} from "../../../components/table";
import Iconify from "../../../components/Iconify";
import AdTypeToolTip from "./AdTypeToolTip";
import {SitesContext} from "../SitesProvider";
import { auth } from '../../../firebase';

const modalStyle = {
    position: 'absolute',
    top: '25%',
    left: '50%',
    transform: 'translate(-50%, -25%)',
    // width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function AdsGrid(props) {
    const sites = useContext(SitesContext);
    const apiRef = useGridApiRef();
    const [openMenu, setOpenMenuActions] = useState(null);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [emailPreviews, setEmailPreviews] = useState([]);
    const [selectedPreview, setSelectedPreview] = useState(0);
    const [user] = useAuthState(auth);

    const handleCloseMenu = () => {
        setOpenMenuActions(null);
    };

    function generateActionMenuForRow(row) {
        const buttons = [];

        buttons.push(
            <MenuItem
                onClick={() => {
                    window.open(`/dashboard/createAd?copyId=${row.id}`);
                }}
                key={"gridAction1"}
            >
                <Iconify icon={'eva:copy-outline'}/>
                <p>Duplicate</p>
            </MenuItem>
        )

        buttons.push(
            <MenuItem
                onClick={() => {
                    window.open(`/dashboard/createAd?id=${row.id}`);
                }}
                key={"gridAction2"}
            >
                <Iconify icon={'eva:edit-2-outline'}/>
                <p>Edit</p>
            </MenuItem>
        )
        buttons.push(
            <MenuItem
                key={"gridAction3"}
                onClick={()=>{
                    user.getIdToken().then((idToken) => {

                        axios.put(`${BASE_HOST}/api/basic/ads`, {
                            id: row.id,
                            status: "off"
                        }, getAccountAPIHeader(idToken)).then(
                          () => {
                              props.refresh()

                              setActionMenu({ ...actionMenu, states: false, loading: false });
                          });
                        setActionMenu({ ...actionMenu, states: false, loading: true });
                    })
                }}
            >
                <Iconify icon={'eva:pause-circle-fill'}/>
                <p>Pause (off)</p>
            </MenuItem>
        )

        return <>
            {buttons}
        </>
    }

    const columns =[
        {
            field: 'name', headerName: "Ad", flex: 1, minWidth: 150,
            renderCell: (params) =><Link href={`/dashboard/createAd?id=${params.row.id}`} target="_blank">{params.row.name}</Link>
        },
        {field: 'type', headerName: "Ad Type"},
        {field: 'status', headerName: "status"},
        {field: 'offerName', headerName: "Offer Name", hide: true},
        {field: 'advertiser', headerName: "Advertiser Name", hide: true},

        {field: 'sent', headerName: "Sent"},
        {field: 'impressions', headerName: "Impressions", hide: true},
        {field: 'clicks', headerName: "Clicks"},
        {field: 'sales', headerName: "Sales", hide: true},
        {field: 'revenue', headerName: "Revenue"},

        {field: 'willServe', headerName: "willServe"},
        {field: 'importWarnings', headerName: "Import Warnings", type: 'number', hide: true},
        {
            field: 'created',
            headerName: 'Created',
            description: 'When the list was initially created',
            width: 150, hide: true, type: 'dateTime',
            // Sorting compares the raw value, so this must stay a Date — formatting
            // here instead sorts "1 April" before "29 January" alphabetically.
            valueGetter: (params) => params.row.created ? new Date(params.row.created) : null,
            valueFormatter: (params) => params.value ? moment(params.value).local(true).format("D MMMM YYYY") : "",
        },
        {
            field: 'updated',
            headerName: 'Last Updated',
            description: 'Last time the list received changes',
            width: 150, hide: true, type: 'dateTime',
            valueGetter: (params) => params.row.updated ? new Date(params.row.updated) : null,
            valueFormatter: (params) => params.value ? moment(params.value).local(true).format("D MMMM YYYY") : "",
        },
        {
            field: "actions",
            headerName: "Actions",
            width: 75,
            renderCell: (params) => <TableMoreMenu
                open={(openMenu != null && openMenu.id === params.row.id) ? openMenu.bind : null}
                onOpen={(event) => setOpenMenuActions({id: params.row.id, bind: event.currentTarget})}
                onClose={handleCloseMenu}
                actions={generateActionMenuForRow(params.row)}
            />
        }
    ];
    
    let hideStates = window.localStorage.getItem("DedicatedHideState")
    if(hideStates){
        hideStates = JSON.parse(hideStates);
        console.log("Dedicated Hide State Found");
        console.log(hideStates);
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(hideStates)) {
          columns.forEach(v=> {if(v.field===key){v.hide=!value} })
        }

        console.log(columns);
        console.log("Dedicated Hide State Complete");
    }


    const [actionMenu, setActionMenu] = useState({mixAds: false, previewAds: false, states: false, loading:false});
    const htmlPreviews = [];
    emailPreviews.forEach((o) => {
        htmlPreviews.push(<div style={{"min-width": "600px",}}>
            <Typography>
                Name: {o.name}<br/>
                Subject Line (sample): {o.subjectLine}<br/>
            </Typography>
            <iframe srcDoc={o.html} seamless width="600px" title={`Email_${o.name}`}/>
        </div>)
    })

    function setStateOnSelected(state) {
        const promisesToAwait = [];
        user.getIdToken().then((idToken) => {
            selectedColumns.forEach((o) => {
                promisesToAwait.push(
                  axios.put(`${BASE_HOST}/api/basic/ads`, { id: o, status: state }, getAccountAPIHeader(idToken))
                )
            });

            Promise.all(promisesToAwait).then(() => {
                setActionMenu({ mixAds: false, previewAds: false, states: false, loading: false });
                props.refresh();
            });
        })
    }

    function CustomToolbar() {
        let customToolBar = <GridToolbarContainer>
            <GridToolbarColumnsButton/>
            <GridToolbarFilterButton/>
            <GridToolbarDensitySelector/>
            <GridToolbarExport/>
        </GridToolbarContainer>;
        if (selectedColumns.length > 0) {
            customToolBar = <GridToolbarContainer>
                <GridToolbarColumnsButton/>
                <GridToolbarFilterButton/>
                <GridToolbarDensitySelector/>
                <GridToolbarExport/>
                <Button variant={"contained"} id="set-state-button"
                        onClick={() => setActionMenu({...actionMenu, states: true})}>
                    Set State
                </Button>



                <Modal
                    open={actionMenu.states}
                    onClose={() => setActionMenu({...actionMenu, states: false})}
                    style={{"overflowY": "scroll"}}
                >
                    <Box sx={{...modalStyle}}>
                        <Typography>
                            Set Ad Status For Selected Ads. <AdTypeToolTip/>
                        </Typography>
                        <Button onClick={() => {
                            setActionMenu({...actionMenu, states: false, loading: true});
                            setStateOnSelected('on');
                        }}>> Set States ON</Button>
                        <br/>
                        <Button onClick={() => {
                            setActionMenu({...actionMenu, states: false, loading: true});
                            setStateOnSelected('off');
                        }}>> Set States To OFF</Button>
                        <br/>
                        <Button onClick={() => {
                            setActionMenu({...actionMenu, states: false, loading: true});
                            setStateOnSelected('fixed');
                        }}>> Set States To FIXED</Button>
                        <br/>
                        <Button onClick={() => {
                            setActionMenu({...actionMenu, states: false, loading: true});
                            setStateOnSelected('archive');
                        }} style={{"background-color": "red"}}>> Set States To Archive</Button>
                    </Box>
                </Modal>

                <Button variant={"contained"}
                        onClick={() => {
                            user.getIdToken().then((idToken) => {

                                axios.post(`${BASE_HOST}/api/basic/preview`, {
                                    "ads": selectedColumns
                                }, getAccountAPIHeader(idToken))
                                  .then(res => {
                                      setSelectedPreview(0);
                                      setEmailPreviews(res.data);
                                      setActionMenu({ ...actionMenu, previewAds: true });
                                  })
                            })
                        }}
                >
                    Preview Ads
                </Button>
                <Modal
                    open={actionMenu.previewAds}
                    onClose={() => setActionMenu({...actionMenu, previewAds: false})}
                    style={{"overflowY": "scroll"}}
                >
                    <Box sx={{...modalStyle,}}>
                        {emailPreviews.length > 0 &&
                        <Carousel
                            autoPlay={false}
                            style={{"position": "initial", "overflow": "unset", "width": "100%"}}
                        >
                            {
                                htmlPreviews
                            }
                        </Carousel>
                        }
                    </Box>
                </Modal>


                <Modal
                    open={actionMenu.mixAds}
                    onClose={() => setActionMenu({...actionMenu, mixAds: false})}
                    style={{"overflowY": "scroll"}}
                >
                    <Box sx={{...modalStyle}}>
                        TODO: API
                    </Box>
                </Modal>

            </GridToolbarContainer>
        }
        return customToolBar
    }

    return (
        <Card>
            <CardHeader title={[
                <Button key={"h1B"} size="Large" align="right" variant="contained"
                        startIcon={<Iconify icon={'eva:edit-2-fill'}/>} color="success"
                        style={{"float": "right"}}


                        onClick={() => {
                            window.open("/dashboard/createAd")
                        }}>
                    Create New
                </Button>
            ]} sx={{mb: 3}}/>
            <div style={{height: Math.max(parseInt(window.innerHeight * .65, 10), 400), width: '100%'}}>
                <DataGrid
                    apiRef={apiRef}
                    rows={props.data}
                    columns={columns}
                    pageSize={50}
                    rowsPerPageOptions={[50]}
                    components={{Toolbar: CustomToolbar}}
                    checkboxSelection
                    disableSelectionOnClick
                    onSelectionModelChange={(v) => setSelectedColumns(v)}
                    onColumnVisibilityModelChange={(newModel) => {
                        console.log("New Hide State Set....");
                        console.log(newModel);
                        console.log("END OF New Hide State Set....");
                         window.localStorage.setItem("DedicatedHideState", JSON.stringify(newModel));
                    }}
                />
            </div>
            <Modal
                    open={actionMenu.loading}
                    style={{"overflowY": "scroll"}}
                >
                    <Box sx={{...modalStyle}}>
                        <Typography>Loading</Typography>
                    </Box>
                </Modal>
        </Card>
    );

}

AdsGrid.propTypes = {
    data: PropTypes.array,
    refresh: PropTypes.func
}